
export const REQUEST_RECRUITSGROUPDATA= 'REQUEST_RECRUITSGROUPDATA';
export const RECRUITSGROUPDATA_RECEIVED = 'RECRUITSGROUPDATA_RECEIVED';